import React, { useState, useEffect } from 'react'
import api from '../api/axios'
import { toast } from 'react-toastify'
import { ReactComponent as NoData } from '../assets/svg/no-data.svg'

const Logs = () => {
  const [logs, setLogs] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const logsPerPage = 10
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchCompletedOrders = async () => {
      setLoading(true)
      const res = await api('GET', 'logs', {})
      setLoading(false)
      console.log(res)
      if (res.status === 200) {
        setLogs(res.data)
      } else {
        toast(res.message, { type: 'error' })
      }
    }
    fetchCompletedOrders()
  }, [])

  const indexOfLastLog = currentPage * logsPerPage
  const indexOfFirstLog = indexOfLastLog - logsPerPage
  const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog)

  const totalPages = Math.ceil(logs.length / logsPerPage)

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  if (loading) {
    return (
      <div className="-mt-[12px] h-[50vh]">
        <div className="c-skeleton-line h-1 w-full -mt-2"></div>
      </div>
    )
  } else {
    return (
      <div className="logs">
        <div className="logs_container p-4">
          <div className="logs_wrapper">
            <h1 className="text-4xl">Logs</h1>
            {Array.isArray(currentLogs) && currentLogs.length > 0 ? (
              <div>
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr>
                      <th className="py-2 px-4 border-b">TimeStamp</th>
                      <th className="py-2 px-4 border-b">Method</th>
                      <th className="py-2 px-4 border-b">Endpoint</th>
                      <th className="py-2 px-4 border-b">User Agent</th>
                      <th className="py-2 px-4 border-b">Ip Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(currentLogs) &&
                      currentLogs.map((item, index) => (
                        <tr key={index} className="text-center">
                          <td className="py-2 px-4 border-b">
                            {item.timeStamp}
                          </td>
                          <td className="py-2 px-4 border-b">{item.method}</td>
                          <td className="py-2 px-4 border-b">{item.url}</td>
                          <td className="py-2 px-4 border-b">
                            {item.user_agent}
                          </td>
                          <td className="py-2 px-4 border-b">{item.ip}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="pagination mt-4">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      className={`mx-1 px-3 py-1 border ${
                        currentPage === index + 1
                          ? 'bg-blue-500 text-white'
                          : 'bg-white text-black'
                      }`}
                      onClick={() => handleClick(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <div className="h-[75vh] w-full flex items-center justify-center">
                <div className="flex flex-col items-center justify-center">
                  <div className="mb-4">
                    <NoData className="h-auto w-[40%] mx-auto" />
                  </div>
                  <p>All clean Here Dang! No Logs Yet!</p>
                  <p>No Data to Show</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Logs
